import {
    GET_DOCUMENT_VERSIONS_SUCCESS,
    GET_DRAFT_STATE_SUCCESS,
    GET_DOCUMENT_VERSION_DETAIL_SUCCESS,
    RECONSTRUCT_DOCUMENT_VERSION_SUCCESS,
    DISCARD_DOCUMENT_DRAFT_SUCCESS,
    RESTORE_DOCUMENT_VERSION_SUCCESS,
    RESET_DOCUMENT_VERSIONS,
} from './documentVersion.types';

const initialState = {
    versions: [],
    draftState: null,
    versionDetail: {}, // { [versionId]: changes[] }
    reconstructed: null,
};

export const documentVersionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DOCUMENT_VERSIONS_SUCCESS:
            return { ...state, versions: action.payload };

        case GET_DRAFT_STATE_SUCCESS:
            return { ...state, draftState: action.payload };

        case GET_DOCUMENT_VERSION_DETAIL_SUCCESS:
            return {
                ...state,
                versionDetail: {
                    ...state.versionDetail,
                    [action.payload.id]: action.payload.changes,
                },
            };

        case RECONSTRUCT_DOCUMENT_VERSION_SUCCESS:
            return { ...state, reconstructed: action.payload };

        case DISCARD_DOCUMENT_DRAFT_SUCCESS:
            return { ...state, draftState: null };

        case RESTORE_DOCUMENT_VERSION_SUCCESS:
            return { ...state, reconstructed: null };

        case RESET_DOCUMENT_VERSIONS:
            return { ...initialState };

        default:
            return state;
    }
};
